import React from 'react';
import { Button, HStack } from '@chakra-ui/react';
import { useLanguage } from '../../context/LanguageContext';

const LanguageSelector = () => {
  const { language, setLanguage } = useLanguage();
  
  return (
    <HStack spacing={2}>
      <Button
        size="sm"
        variant={language === 'es' ? 'solid' : 'outline'}
        onClick={() => setLanguage('es')}
        colorScheme="brand"
        borderRadius="md"
        px={3}
        py={1}
        fontSize="sm"
        fontWeight="medium"
        _hover={{
          bg: language === 'es' ? 'brand.main' : 'transparent',
          color: language === 'es' ? 'white' : 'brand.main',
        }}
      >
        ES
      </Button>
      <Button
        size="sm"
        variant={language === 'en' ? 'solid' : 'outline'}
        onClick={() => setLanguage('en')}
        colorScheme="brand"
        borderRadius="md"
        px={3}
        py={1}
        fontSize="sm"
        fontWeight="medium"
        _hover={{
          bg: language === 'en' ? 'brand.main' : 'transparent',
          color: language === 'en' ? 'white' : 'brand.main',
        }}
      >
        EN
      </Button>
    </HStack>
  );
};

export default LanguageSelector; 